import { render, staticRenderFns } from "./header-mob.vue?vue&type=template&id=6dd922f6&scoped=true"
import script from "./header-mob.vue?vue&type=script&lang=js"
export * from "./header-mob.vue?vue&type=script&lang=js"
import style0 from "./header-mob.vue?vue&type=style&index=0&id=6dd922f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd922f6",
  null
  
)

export default component.exports